// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#uaqcResults .listings__table .el-table table thead tr th .cell {\n  text-transform: none !important;\n}", ""]);
// Exports
module.exports = exports;
